angular.module("listingOverviewModule").component('buildingPreDevPopup', {
    templateUrl: 'buildingPreDevPopup/buildingPreDevPopup.html',
    transclude:true,
    bindings: {},
    controller: ['$scope', '$timeout', '$interval', '$window', "$cookies", '$rootScope', 'PubSub', '$element', '$document', 'crResourcesService', "patterns",
    function($scope, $timeout, $interval, $window, $cookies, $rootScope, PubSub, $element, $document, crResourcesService, patterns) {
        let ctrl = this;
        let popupChild;

		ctrl.lastKeyPressed = null;
		ctrl.patterns = patterns;
		ctrl.onKeyDown = function(e) {
			ctrl.lastKeyPressed = e.keyCode;
        };
        ctrl.buildingName = null;
        ctrl.buildingToken = null;
        ctrl.rpc = null;
        ctrl.user = null;
        ctrl.formData = {
            name: null,
            email: null,
            phone: null,
            popup: 'building-research-report',
            bldg_token: null,
            subscribe: true,
            isLoading: false
        }
        ctrl.isFirstStep = true;

        this.$onInit = function() {
            // Move the component to the body
            popupChild = $element[0].querySelector('.cmp-building-pre-dev-popup');

            // hide on overlay click
            angular.element(popupChild).on('click', function(event) {
                // let popupBlock = $element[0].querySelector('.popup-block');
                let closeButton = $element[0].querySelector('.close');
                let continueButton = $element[0].querySelector('.continue');

                // if (popupBlock && !popupBlock.contains(event.target)) {
                //     angular.element(popupChild).removeClass('visible');
                // }

                if (closeButton && closeButton.contains(event.target)) {
                    angular.element(popupChild).removeClass('visible');
                }

                if (continueButton && continueButton.contains(event.target)) {
                    angular.element(popupChild).removeClass('visible');
                }
            });
        };

        ctrl.submitForm = function(form) {
            ctrl.formData.isLoading = true;

            if (form.$valid) {
                window.crRecaptcha.execute(() => {
                    ctrl.submitFormData(form);
                });
            } else {
                form.$setSubmitted();
                ctrl.formData.isLoading = false;
            }
        };


        ctrl.submitFormData = function(form) {
            ctrl.formData.reCaptchaTokens = window.crRecaptcha.getTokens();
            let dataToSend = Object.assign({}, ctrl.formData);

            let crDataPromise = crResourcesService.post(ctrl.rpc, dataToSend);
            crDataPromise
            .then(function(data) {
                if (data["RPCFormReusableContact_FORMSUMMARY"][0].status) {

                    /**
                     * In case we'll need to update
                     * SAME form entry on "update email" click
                     */
                    ctrl.formData.token = data["RPCFormReusableContact_FORMSUMMARY"][0].token;

                    // disable exit popups
                    if (data["RPCFormReusableContact_FORMSUMMARY"][0].regUsrToken != null) {
                        var now = new Date(),
                            exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5); // set the expiration to 5 days ahead
                        $cookies.put('exitPopupShown', 'true', { expires: exp });
                    }
                    ctrl.isFirstStep = false;
                } else {
                    if (data["RPCFormReusableContact_name"]) {
                        let error = data["RPCFormReusableContact_name"];
                        form.name.$setValidity("pattern", false);
                        form.name.customErrorMessage = error[0];
                    }
                    if (data["RPCFormReusableContact_dayphone"]) {
                        let error = data["RPCFormReusableContact_dayphone"];
                        form.phone.$setValidity("pattern", false);
                        form.phone.customErrorMessage = error[0];
                    }
                    if (data["RPCFormReusableContact_email"]) {
                        let error = data["RPCFormReusableContact_email"];
                        form.email.$setValidity("pattern", false);
                        form.email.customErrorMessage = error[0];
                    }
                }
                ctrl.formData.isLoading = false;
            })
            .catch(function(error) {
                ctrl.formData.isLoading = false;
                console.error('An error occurred:', error);
            });
        };

        ctrl.resendEmail = function () {
            ctrl.formData.isLoading = true;
            window.crRecaptcha.execute(() => {
                ctrl.resendEmailData();
            });
        }
        ctrl.resendEmailData = function () {
            ctrl.formData.reCaptchaTokens = window.crRecaptcha.getTokens();
            let dataToSend = Object.assign({}, ctrl.formData);

            let crDataPromise = crResourcesService.post(ctrl.rpc, dataToSend);
            crDataPromise
            .then(function(data) {
                if (data["RPCFormReusableContact_FORMSUMMARY"][0].status) {
                    /**
                     * In case we'll need to update
                     * SAME form entry on "update email" click
                     */
                    ctrl.formData.token = data["RPCFormReusableContact_FORMSUMMARY"][0].token;
                    ctrl.isFirstStep = false;
                }
                ctrl.formData.isLoading = false;
            })
            .catch(function(error) {
                ctrl.formData.isLoading = false;
                console.error('An error occurred:', error);
            });
        }

        $rootScope.$on('openBuildingPreDevPopup', function(event, data) {
          if (popupChild) {
            $timeout(function () {
                ctrl.isFirstStep = true;
                ctrl.buildingToken = data.buildingToken ? data.buildingToken : null;
                ctrl.buildingName = data.buildingName;
                ctrl.user = data.user;
                ctrl.rpc = data.rpc;
                if (ctrl.user) {
                    ctrl.formData.name = ctrl.user.name;
                    ctrl.formData.email = ctrl.user.email;
                    ctrl.formData.phone = ctrl.user.phone;
                    ctrl.formData.bldg_token = ctrl.buildingToken;
                }

                $scope.$apply();
                angular.element(popupChild).addClass('visible');
            });
          }
        });

    }]
});

/**
 * Initialization stuff below + listener,
 * component logic is above, so everything below
 * can be left as is in most cases.
 */

angular.module("listingOverviewModule").run(['$document', '$rootScope', '$compile', function($document, $rootScope, $compile) {
    const body = angular.element($document[0].body);
    if (!body[0].querySelector('.cmp-building-pre-dev-popup')) {
        // Dynamically compile and append the component
        const popupElement = $compile('<building-pre-dev-popup></building-pre-dev-popup>')($rootScope.$new());
        body.append(popupElement);
    }
}]);

// External button click handler that triggers the AngularJS event
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function (event) {
    let target = event.target.closest('.open-building-pre-dev-popup'); // Find the closest element with this class
    if (target) {
      let rpc = target.getAttribute('data-rpc');
      let buildingToken = target.getAttribute('data-building-token');
      let userData = JSON.parse(target.getAttribute('data-user'));
      let buildingName = target.getAttribute('data-building-name');

      // Trigger AngularJS event
      let injector = angular.element(document.body).injector();
      let rootScope = injector.get('$rootScope');

      rootScope.$apply(function() {
        rootScope.$broadcast('openBuildingPreDevPopup', {
          buildingToken: buildingToken ? buildingToken : null,
          user: userData,
          buildingName: buildingName,
          rpc: rpc
        });
      });
    }
  });
});
